import axios from "axios";

export const getJobPositions = callback => {
  var promise = axios({
    method: "get",
    url: "/api/job_positions"
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};
